import { defineMessage, MessageDescriptor } from 'react-intl';

export const redeemMessages: { [key: string]: MessageDescriptor } = {
  completeProfileDescription: defineMessage({
    id: 'confirmationPopupDescription:redeemPointsOnOfferNoProfileCompleted',
    defaultMessage: 'To access this offer, please complete your profile first.',
    description:
      'Description shown on the edit profile popup when user tries to redeem an offer and profile is not completed',
  }),
  redeemPointsTitle: defineMessage({
    id: 'confirmationPopupTitle:redeemPointsOnOffer',
    defaultMessage: 'Redeem Offer',
    description: 'Title in confirmation popup when ask to redeem points on offers',
  }),
  redeemPointsDescription: defineMessage({
    id: 'confirmationPopupDescription:redeemPointsOnOffer:markdown',
    defaultMessage:
      'You will have {expiresIn} to redeem this reward in store. Are you sure you would like to redeem it now?',
    description: 'Message to inform user in confirmation popup with ask to redeem points on offer',
  }),
  redeemPointsNoExpirationDaysDescription: defineMessage({
    id: 'confirmationPopupDescription:redeemPointsOnOfferNoExpirationDays',
    defaultMessage: 'Are you sure you would like to redeem this offer now?',
    description:
      'Message to inform user in confirmation popup with ask to redeem points on offer if offer does not have expiration days',
  }),
  redeemPointsConfirmButton: defineMessage({
    id: 'confirmationPopupButton:redeemPointsOnOffer',
    defaultMessage: 'Confirm',
    description: 'Confirm button text in confirmation popup with ask to redeem points on offer',
  }),
};
